function getSearchURLParams(url)
{
    if(typeof url !== "string") {
        return {};
    }
   var urlSplit = url.split("?");
   if(urlSplit.length < 2) {
       return {};
   }
   return _.object(_.map(urlSplit[1].split("&"), function(params) {
       return params.split("=");
   }));
}
var jQuery = require("jQuery");
function getSuitelet(script, deploy) {
   return {"customscript_ns_sc_ext_sl_sn_sub:customdeploy_create_subscription":"/app/site/hosting/scriptlet.nl?script=4932&deploy=1&compid=5274210_SB1&ns-at=AAEJ7tMQozcU00Bz1OuHcPyM8-osbZV1bWRH1A9i3nEFZ9csiCk","customscript_ns_sc_sl_blog_entity_loader:customdeploy_ns_sc_sl_blog_entity_loader":"/app/site/hosting/scriptlet.nl?script=2249&deploy=1&compid=5274210_SB1&ns-at=AAEJ7tMQvUw8uesrML9WybkRBZb59343I_e77fYt7eSpIClwvAI","customscript_ns_sc_sl_blog_post_searcher:customdeploy_ns_sc_sl_blog_post_searcher":"/app/site/hosting/scriptlet.nl?script=2251&deploy=1&compid=5274210_SB1&ns-at=AAEJ7tMQyf6cjfFLj6vw1Fj3JpO3i-WDKyaaA8_Y-Anw0me9nEo","customscript_ns_sc_sl_blog_url_prov:customdeploy_ns_sc_sl_blog_url_prov_dep":"/app/site/hosting/scriptlet.nl?script=2250&deploy=1&compid=5274210_SB1&ns-at=AAEJ7tMQ7ceHbhH7oXQtCiFNBhLCZ7gvgTnlwJxayfiROpwasSY","customscript_ns_sc_sl_contact_us_form:customdeploy_ns_sc_sl_contact_us_form":"/app/site/hosting/scriptlet.nl?script=2259&deploy=1&compid=5274210_SB1&ns-at=AAEJ7tMQTaGUK4UUdG7a4d3b56cRBPVm3cBIusJ5z_cwik_hmAw","customscript_ns_sc_sl_sn_get_subs:customdeploy_ns_sc_sl_sn_get_subs":"/app/site/hosting/scriptlet.nl?script=4931&deploy=1&compid=5274210_SB1&ns-at=AAEJ7tMQ2Ftx4tFx9VpITV8ckVenL6upylU4Rklr2pspLL4HJEQ","customscript_ns_sc_sl_sn_isb:customdeploy_ns_sc_sl_sn_isb":"/app/site/hosting/scriptlet.nl?script=5566&deploy=1&compid=5274210_SB1&ns-at=AAEJ7tMQJk4JfaeXrJabs6i3on04acR85swAi2G1bCptQNVjGr0","customscript_ns_sc_sl_sn_subswitch:customdeploy_ns_sc_sl_sn_subswitch":"/app/site/hosting/scriptlet.nl?script=4930&deploy=1&compid=5274210_SB1&ns-at=AAEJ7tMQ4R_zKVegankylK3f3Eg9Ksfpx7-r6CjSt3yTN5e3ZM0"}[script + ":" + deploy];
}
var xhrFactory = jQuery.ajaxSettings.xhr;
jQuery.ajaxSettings.xhr = function() {
   var xhr = xhrFactory.apply(this, arguments);
   var open = xhr.open;
   xhr.open = function () {
        var url = arguments[1];
        var assocParams = getSearchURLParams(url);
        if(assocParams.hasOwnProperty("script") && assocParams.hasOwnProperty("deploy")) {
            var hashed = getSuitelet(assocParams["script"], assocParams["deploy"]);
            if(hashed) {
                var hashedParams = getSearchURLParams(hashed);
                var keys = Object.keys(assocParams);
                for (var i=0; i<keys.length; i++) {
                    var key = keys[i];
                    var value = assocParams[key];
                    if(!hashedParams.hasOwnProperty(key))
                    {
                        hashed += "&" + key + "=" + value;
                    }
                }
                arguments[1] = hashed;
            }
        }
        return open.apply(this, arguments);
    }
    return xhr;
}